export default {
  distinguishOrgDimensions: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000144","区分组织维度:") /* "区分组织维度:" */,
  addOrgBusiness: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000145","新增组织业务") /* "新增组织业务" */,
  OrgBusinessCorrespondence: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000146","组织业务对应") /* "组织业务对应" */,
  addRow: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000147","增行") /* "增行" */,
  switchDimensionInfo: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000148","切换维度将清空所有的组织的维度，确认切换吗？") /* "切换维度将清空所有的组织的维度，确认切换吗？" */,
  demisionNotNull: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000149","维度值不能为空!") /* "维度值不能为空!" */
};
